// Central static content for the permanent institutional site.
// Session-specific data (session, status, fees, deadline, contacts, announcements, FAQs)
// comes from the backend /api/config and is editable via the Admin dashboard.

export const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_47ee1fc3-7e49-4aa6-9f96-956ec52c90a1/artifacts/32vrmnbm_ChatGPT%20Image%20Aug%2023%2C%202026%2C%2008_49_45%20AM.png";

// Official uploaded flyer artwork — shown as framed showcases (never behind body text).
const FLYER_WIDE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_47ee1fc3-7e49-4aa6-9f96-956ec52c90a1/artifacts/7k067qy9_ChatGPT%20Image%20Aug%2023%2C%202026%2C%2008_46_13%20AM.png";
const FLYER_LANDSCAPE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_47ee1fc3-7e49-4aa6-9f96-956ec52c90a1/artifacts/0ikyzc32_ChatGPT%20Image%20Aug%2023%2C%202026%2C%2008_21_07%20AM.png";
const FLYER_PORTRAIT =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_47ee1fc3-7e49-4aa6-9f96-956ec52c90a1/artifacts/gcoklij2_ChatGPT%20Image%20Aug%2023%2C%202026%2C%2008_21_03%20AM.png";

export const IMAGES = {
  hero: FLYER_PORTRAIT,
  portrait: FLYER_PORTRAIT,
  library: FLYER_WIDE,
  collaborating: FLYER_LANDSCAPE,
  graduation: FLYER_WIDE,
  campus: FLYER_LANDSCAPE,
  flyerWide: FLYER_WIDE,
  flyerLandscape: FLYER_LANDSCAPE,
  flyerPortrait: FLYER_PORTRAIT,
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "JUPEB", to: "/jupeb" },
  { label: "IJMB", to: "/ijmb" },
  { label: "Remedial", to: "/remedial" },
  { label: "Programmes", to: "/programmes" },
  { label: "Admissions", to: "/admissions" },
  { label: "Student Info", to: "/student-information" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];

export const STATUS_META = {
  OPEN: { label: "Admissions Open", tone: "open", dot: "#22c55e" },
  CLOSING_SOON: { label: "Applications Closing Soon", tone: "warn", dot: "#F5B301" },
  CLOSED: { label: "Applications Closed", tone: "closed", dot: "#C0202A" },
  COMING_SOON: { label: "Next Session Coming Soon", tone: "soon", dot: "#93a3c9" },
};

export const BENEFITS = [
  { title: "Quality Teaching", body: "Highly qualified and experienced lecturers providing structured academic instruction.", icon: "GraduationCap" },
  { title: "Academic Mentorship", body: "Guidance and mentorship to help students develop confidence and academic discipline.", icon: "Users" },
  { title: "Conducive Learning Environment", body: "A focused environment designed to support learning and student development.", icon: "BookOpen" },
  { title: "Accessible Location", body: "School of Basic Studies, St. John's Campus, Aba Road, Port Harcourt, Rivers State.", icon: "MapPin" },
  { title: "University-Focused Preparation", body: "Prepare for the academic demands of university education.", icon: "Target" },
  { title: "Direct Entry Pathway", body: "Prepare for eligible Direct Entry opportunities following successful completion and relevant requirements.", icon: "Route" },
];

export const PILLARS = [
  { k: "Learn", body: "Quality academic instruction." },
  { k: "Grow", body: "Develop confidence and discipline." },
  { k: "Prepare", body: "Prepare for advanced-level examinations." },
  { k: "Progress", body: "Move toward eligible university admission opportunities." },
];

export const ELIGIBILITY = [
  "SSCE holders",
  "Awaiting Result candidates",
  "Eligible SSS3 students",
  "Candidates who did not sit for UTME",
  "Candidates who sat for UTME but failed to secure university admission",
  "Candidates seeking alternative admission pathways",
  "Candidates preparing for Direct Entry opportunities",
];

export const COURSE_AREAS = [
  { name: "Medicine & Health-related fields", courses: ["Medicine & Surgery", "Nursing Science", "Medical Laboratory Science", "Pharmacy", "Physiology", "Anatomy"] },
  { name: "Engineering", courses: ["Mechanical Engineering", "Civil Engineering", "Electrical/Electronic Engineering", "Chemical Engineering", "Petroleum Engineering"] },
  { name: "Law", courses: ["Law (LL.B)"] },
  { name: "Education", courses: ["Education & Biology", "Education & Economics", "Education & English", "Education & Mathematics", "Guidance & Counselling"] },
  { name: "Management Sciences", courses: ["Accounting", "Business Administration", "Banking & Finance", "Marketing", "Public Administration"] },
  { name: "Social Sciences", courses: ["Economics", "Political Science", "Sociology", "Mass Communication", "Psychology"] },
  { name: "Natural Sciences", courses: ["Biochemistry", "Microbiology", "Physics", "Chemistry", "Mathematics", "Computer Science"] },
  { name: "Agriculture", courses: ["Agricultural Science", "Agricultural Economics", "Animal Science", "Crop Science"] },
  { name: "Environmental Sciences", courses: ["Architecture", "Estate Management", "Urban & Regional Planning", "Surveying & Geoinformatics"] },
  { name: "Humanities", courses: ["English & Literary Studies", "History & International Studies", "Philosophy", "Religious Studies", "Linguistics"] },
  { name: "Other approved areas", courses: ["Subject to the receiving institution and applicable admission requirements."] },
];

export const REMEDIAL_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/47ee1fc3-7e49-4aa6-9f96-956ec52c90a1/images/eb86f7f78de785188400b2f5f6fe454efe43690f724824ed14f0227263c30ca0.jpeg";

export const REMEDIAL = {
  title: "Remedial Programme",
  subtitle: "A structured foundation programme that prepares candidates for JAMB UTME and admission into Ignatius Ajuru University of Education.",
  intro: "The Remedial Programme is a focused one-session foundation designed for candidates who need to strengthen their O'Level results and prepare thoroughly for JAMB UTME. On successful completion, remedial students proceed into Ignatius Ajuru University of Education.",
  requirements: [
    "A minimum of 5 O'Level credits — particularly the subjects you'll write in JAMB",
    "Your chosen relevant course of study",
    "Completed application / enquiry form",
  ],
  courseStudy: "All remedial students proceed into our University — Ignatius Ajuru University of Education.",
};

export const SUBJECT_COMBINATIONS = {
  JUPEB: [
    { area: "Medical & Health Sciences", subjects: "Biology, Chemistry, Physics" },
    { area: "Engineering", subjects: "Mathematics, Physics, Chemistry" },
    { area: "Physical Sciences", subjects: "Mathematics, Physics, Chemistry" },
    { area: "Management Sciences", subjects: "Accounting, Economics, Business/Mathematics" },
    { area: "Social Sciences", subjects: "Economics, Government, Mathematics" },
    { area: "Law", subjects: "Literature-in-English, Government, Christian Religious Studies" },
    { area: "Arts & Humanities", subjects: "Literature-in-English, Government/History, CRS" },
  ],
  IJMB: [
    { area: "Medical & Health Sciences", subjects: "Biology, Chemistry, Physics" },
    { area: "Engineering", subjects: "Mathematics, Physics, Chemistry" },
    { area: "Physical Sciences", subjects: "Mathematics, Physics, Chemistry" },
    { area: "Management Sciences", subjects: "Accounting, Economics, Mathematics" },
    { area: "Social Sciences", subjects: "Economics, Government/Geography, Mathematics" },
    { area: "Law", subjects: "Literature-in-English, Government, CRS/History" },
    { area: "Arts & Humanities", subjects: "Literature, History/Government, CRS" },
  ],
  REMEDIAL: [
    { area: "Sciences", subjects: "5 O'Level credits including Mathematics, English and your JAMB science subjects" },
    { area: "Management Sciences", subjects: "5 O'Level credits including Mathematics, English and your JAMB subjects" },
    { area: "Social Sciences", subjects: "5 O'Level credits including English and your JAMB social science subjects" },
    { area: "Arts & Humanities", subjects: "5 O'Level credits including English and your JAMB arts subjects" },
  ],
};

export const COMPARE_ROWS = [
  ["Programme Type", "Advanced-level", "Advanced-level", "Remedial / Foundation"],
  ["Academic Preparation", "Yes", "Yes", "Yes"],
  ["Examination", "JUPEB Exam", "IJMB Exam", "JAMB UTME"],
  ["Pathway Outcome", "Eligible Direct Entry (200L)", "Eligible Direct Entry (200L)", "Admission into IAUE"],
  ["Entry Requirement", "O'Level credits", "O'Level credits", "5 O'Level credits + JAMB subjects"],
  ["Duration", "Configurable per session", "Configurable per session", "Configurable per session"],
];

export const TIMELINE = ["Enrol", "Learn", "Prepare", "Examine", "Qualify", "Apply"];

export const DIRECT_ENTRY_STEPS = [
  { n: "01", t: "Choose your pathway", d: "Select JUPEB or IJMB based on your goals and intended course area." },
  { n: "02", t: "Complete the academic programme", d: "Attend structured lessons and build a strong academic foundation." },
  { n: "03", t: "Prepare for and complete the examination", d: "Prepare thoroughly and sit the relevant advanced-level examination." },
  { n: "04", t: "Obtain your qualification", d: "Receive your result and qualification upon successful completion." },
  { n: "05", t: "Apply for eligible Direct Entry opportunities", d: "Use your qualification to pursue eligible Direct Entry into 200 Level." },
];

export const APPLICATION_STEPS = [
  "Explore programme",
  "Confirm eligibility",
  "Choose JUPEB or IJMB",
  "Complete application",
  "Submit required documents",
  "Receive confirmation",
  "Begin programme",
];

export const PARENT_POINTS = [
  "Academic supervision",
  "Qualified lecturers",
  "Structured learning",
  "Mentorship",
  "Conducive environment",
  "Accessibility",
  "Clear communication",
  "Academic preparation",
];

export const ABOUT = {
  who: "The School of Basic Studies is an academic environment within Ignatius Ajuru University of Education dedicated to preparing candidates for the next stage of their education through structured advanced-level programmes.",
  approach: "We combine quality teaching, mentorship, discipline and examination preparation to help students build a stronger foundation for university readiness and personal development.",
  why: "The School exists to provide eligible candidates with a credible, structured pathway toward university education — including those seeking an alternative route toward Direct Entry opportunities.",
};

export const DISCLAIMERS = {
  directEntry:
    "Successful candidates may use their qualification to pursue eligible Direct Entry opportunities, subject to the admission requirements of the receiving institution and programme.",
  courseChoice:
    "Available pathways depend on the candidate's subject combination, chosen programme, receiving institution, and applicable admission requirements.",
  eligibility: "Eligibility requirements may vary by programme and academic session.",
  deAdmission:
    "Direct Entry admission is subject to the requirements of the receiving university, chosen programme, available spaces, and applicable admission regulations.",
};

export const MAPS_QUERY = "St.+John's+Campus+Ignatius+Ajuru+University+of+Education+Aba+Road+Port+Harcourt";
